<template>
  <div>
    <van-notify v-model="showShareTips" type="success" className="share-tips" duration="5000">
      <div class="share-tips-content"><strong>点击右上角的"...", 选择"发送给朋友"</strong><img alt="" src="../assets/img_wx_more.png" /></div>
    </van-notify>
    <van-dialog 
      v-bind:value="show"
      @input="$emit('input', !show)"
      title="让好友扫此二维码代付" 
      :overlay-style="{'z-index':2002}" 
      show-cancel-button cancel-button-text="关闭" 
      confirm-button-text="转发给好友"
      :before-close="onClose"
    >
        <div class="payment-share-body">
          <div>
            <qrcode-vue :value="paymentLink || ''" size="240" />
          </div>
          <div class="tips">等待支付....</div>
        </div>
      </van-dialog>
  </div>
  
</template>
<script>
import { Checkbox, Dialog, Icon, Notify, Tag, Toast } from 'vant'
import QrcodeVue from 'qrcode.vue';
/*
const copy = text => {
  if (navigator.clipboard) {
    // clipboard api 复制
    navigator.clipboard.writeText(text);
  } else {
      var textarea = document.createElement('textarea');
      document.body.appendChild(textarea);
      // 隐藏此输入框
      textarea.style.position = 'fixed';
      textarea.style.clip = 'rect(0 0 0 0)';
      textarea.style.top = '10px';
      // 赋值
      textarea.value = text;
      // 选中
      textarea.select();
      // 复制
      document.execCommand('copy', true);
      // 移除输入框
      document.body.removeChild(textarea);
  }
}

*/
const component = {
  name: 'PaymentSharePopup',
  components: {
    [Icon.name] : Icon,
    [Tag.name] : Tag,
    [Checkbox.name] : Checkbox,
    [Dialog.Component.name]: Dialog.Component,
    [Notify.Component.name]: Notify.Component,
    'qrcode-vue' : QrcodeVue
  },
  model: {
    prop: 'show',
    event: 'input'
  },
  data() {
    return {
      showShareTips : false,
      timeoutId : null,
      intervalId: null,
      paymentLink: null,
      isMiniProgram: false
    }
  },
  mounted() {
    const that = this;
    this.$wechat.sdk(sdk => {
        sdk.miniProgram.getEnv(function(res) {
          that.isMiniProgram = res.miniprogram;
        })
    });
  },
  beforeDestroy(){
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
  },
  props: {
    tradeNo: String,
    show: Boolean
  },
  watch: {
    show(value) {
      const { protocol, host, pathname } = window.location;
      this.paymentLink = protocol + "//" + host + pathname.replace(/\/[^/]+/, '/pay_for_friend') + '?tradeNo=' + this.tradeNo;
      console.log(this.paymentLink);
      clearInterval(this.intervalId);
      // 打开
      if (value) {
        this.intervalId = setInterval(()=>{
          this.$http.get('/payment', {tradeNo : this.tradeNo}).then(state => {
            if (state.paid) {
              this.$emit('paid', this.tradeNo);
              this.$emit('input', false);
              clearTimeout(this.timeoutId);
              this.showShareTips = false;
            }
          })
          
        }, 5000);
      }
    }
  },
  methods: {
    wechatShare(){
      console.log('share...')
			this.$wechat.sdk(wechat => {
				wechat.showOptionMenu();
				wechat.hideAllNonBaseMenuItem();
				wechat.showMenuItems({
					menuList: ['menuItem:share:appMessage','menuItem:share:timeline'] // 要显示的菜单项，所有menu项见附录3
				});
				var title = '请帮我付款';
				var desc = '体现你我真感情的时刻到了! 我现在需要你帮我支付一笔停车月租费';
				var imgUrl = 'http://static.qparking.cn/img/icon_kjlt_txt.jpg';
				wechat.onMenuShareAppMessage({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: this.paymentLink, // 分享链接
          imgUrl: imgUrl, // 分享图标
          type: 'link', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function () { 
              // 用户确认分享后执行的回调函数
          },
          cancel: function () { 
            // 用户取消分享后执行的回调函数
          }
				});
				wechat.onMenuShareTimeline({
          title: title, // 分享标题
          link: this.paymentLink, // 分享链接
          imgUrl: imgUrl, // 分享图标
          success: function () { 
                 // 用户确认分享后执行的回调函数
          },
          cancel: function () { 
              // 用户取消分享后执行的回调函数
          }
				});
			});
    },
    onClose(action, done){
      if (action == 'confirm') {
        //小程序内只能复制链接分享
        if (this.isMiniProgram) {
          // copy(this.paymentLink);
          Toast({
            position: 'top',
            message: '您可以将此代付二维码截图，发送给好友',
            duration: 5000
          });
          done(false);
        } else {
          this.showShareTips = true;
          this.wechatShare();
          clearTimeout(this.timeoutId);
          this.timeoutId = setTimeout(()=> {
            this.showShareTips = false;
          }, 5000)
          done(false);
          }
      } else {
        clearTimeout(this.timeoutId);
        this.showShareTips = false;
        done();
      }
    }
  },
}

export default component;
</script>
<style lang="less" scoped>
.share-tips{
  z-index: 10000;
}
.share-tips-content {
  text-align: right;
  width: 100%;
  img {
    height: 2.5em
  }
}
.payment-share-body{
  text-align: center;
  padding: 10px;
  .tips {
    margin: 10px;
    color: gray;
  }
}

</style>